export default "__VITE_ASSET__7IkL3nP___"